import type { Dict } from '../utils'

import { createContext } from '../utils'

const [StepperHorizontalProvider, useStepperHorizontalContext] = createContext<Dict>({ isOptional: true })

export { StepperHorizontalProvider, useStepperHorizontalContext }
